export default __webpack_public_path__ + "static/media/EmbracingDeath.37538532.mp3";